// angular
import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// components
import { ProductCardComponent } from '@app/core/components/product-card/product-card.component';
import { SectionsTitleComponent } from '@app/core/components/sections-title/sections-title.component';
import { ButtonComponent } from '@app/core/components/button/button.component';
import { ProductCardSkeletonComponent } from '@app/core/components/product-card/product-card-skeleton/product-card-skeleton.component';
// interfaces
import { IProduct } from '@app/+products/shared/interfaces/product.interface';
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
@Component({
  selector: 'pwj-top-products-section',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    ProductCardComponent,
    SectionsTitleComponent,
    ButtonComponent,
    TranslateModule,
    NgxSkeletonLoaderModule,
    NoContentComponent,
    ProductCardSkeletonComponent,
  ],
  templateUrl: './top-products-section.component.html',
  styleUrl: './top-products-section.component.scss',
})
export class TopProductsSectionComponent {
  // inputs
  isPortfolioMode = input<boolean>();
  topProducts = input.required<IProduct[]>();
  productsCount = input<number>();
  productsLoading = input<boolean>();
}
